const hasNumber = (val: string): boolean => /\d/.test(val);

export default hasNumber;
